import { useCallback, useEffect, useRef } from "react";

export function useHoverCloseDelay(
  onClose: () => void,
  delayMs: number,
): { cancelClose: () => void; scheduleClose: () => void } {
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
      }
    };
  }, []);

  const cancelClose = useCallback(() => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  }, []);

  const scheduleClose = useCallback(() => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
    }
    closeTimerRef.current = setTimeout(() => {
      onClose();
      closeTimerRef.current = null;
    }, delayMs);
  }, [onClose, delayMs]);

  return { cancelClose, scheduleClose };
}
